import types from '../types';
import { getResetedCheckboxGroupState } from '.';

/**
 * @param {types.Filter | types.Select} filter
 * @returns {types.Filter | types.Select}
 */
const getResetedFilter = filter => {
    switch (filter.type) {
        case 'checkbox': {
            return {
                ...filter,
                options: getResetedCheckboxGroupState(filter.options)
            };
        }

        case 'select': {
            return {
                ...filter,
                value: null
            };
        }

        default:
            return filter;
    }
};

/**
 * @param {types.Filter[] | types.Select[]} filters
 * @returns {types.Filter[] | types.Select[]}
 */
const getResetedFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(getResetedFilter);
};

export default getResetedFilters;
